import React, { useState, useEffect, useRef } from "react";
import { Stack, FormControl } from "@mui/material";
import { getDateArray, range } from "../utils/dateUtil";

const DateSelector = ({ birthday = "", setBirthday }) => {
  // 本年
  const today = new Date();
  const thisYear = today.getFullYear();
  const thisMonth = today.getMonth() + 1;
  const thisDay = today.getDate();
  //生年月日
  const dataBirthday = birthday?.split("-") || [];
  //毎月、日数
  const [dateSelection, setDateSelection] = useState(
    dataBirthday && dataBirthday.length > 2
      ? range(
          1,
          getDateArray(Number(dataBirthday[0]))[Number(dataBirthday[1]) - 1] + 1
        )
      : []
  );
  //年
  const [year, setYear] = useState(
    dataBirthday && dataBirthday.length > 2 ? dataBirthday[0] : ""
  );
  //月
  const [month, setMonth] = useState(
    dataBirthday && dataBirthday.length > 2 ? dataBirthday[1] : ""
  );
  //日
  const [date, setDate] = useState(
    dataBirthday && dataBirthday.length > 2 ? dataBirthday[2] : ""
  );
  //未来月制御
  const [maxMonth, setMaxMonth] = useState(13);

  // 初回render反応しないように
  const RENDER_TIME = process.env.NODE_ENV === "development" ? 1 : 0;
  const firstRenderRef = useRef(0);

  //年変更
  useEffect(() => {
    if (firstRenderRef.current > RENDER_TIME) {
      setMonth("");
      setDate("");
      setDateSelection([]);
      if (year.toString() === thisYear.toString()) {
        setMaxMonth(thisMonth + 1);
      } else {
        setMaxMonth(13);
      }
    }
  }, [year]);
  //月変更
  useEffect(() => {
    if (firstRenderRef.current > RENDER_TIME) {
      setDate("");
      if (month) {
        const maxDate =
          year.toString() === thisYear.toString() &&
          month.toString() === thisMonth.toString()
            ? thisDay
            : getDateArray(year)[month - 1];
        setDateSelection(range(1, maxDate + 1));
      } else {
        setDateSelection([]);
      }
    }
  }, [month]);
  //日変更
  useEffect(() => {
    if (firstRenderRef.current > RENDER_TIME) {
      if (date) {
        setBirthday(`${year}-${month}-${date}`);
      }
    }
    firstRenderRef.current = firstRenderRef.current + 1;
  }, [date]);

  return (
    <Stack direction="row" width="85%">
      <Stack direction="row" width="40%" alignItems="center" paddingRight="1%">
        <FormControl fullWidth>
          <select
            style={{ height: "4vh" }}
            id="year"
            name="year"
            value={year}
            onChange={(event) => setYear(event.target.value)}
          >
            <option value="" />
            {range(1900, thisYear + 1)
              .reverse()
              .map((year, index) => (
                <option key={index} value={year.toString()}>
                  {year}
                </option>
              ))}
          </select>
        </FormControl>
        年
      </Stack>
      <Stack direction="row" width="30%" alignItems="center" paddingRight="1%">
        <FormControl fullWidth>
          <select
            style={{ height: "4vh" }}
            id="month"
            name="month"
            value={month}
            onChange={(event) => setMonth(event.target.value)}
          >
            <option value="" />
            {range(1, maxMonth).map((month, index) => (
              <option key={index} value={month.toString()}>
                {month}
              </option>
            ))}
          </select>
        </FormControl>
        月
      </Stack>
      <Stack direction="row" width="30%" alignItems="center">
        <FormControl fullWidth>
          <select
            style={{ height: "4vh" }}
            id="day"
            name="day"
            value={date}
            onChange={(event) => setDate(event.target.value)}
          >
            <option value="" />
            {dateSelection.map((day, index) => (
              <option key={index} value={day.toString()}>
                {day}
              </option>
            ))}
          </select>
        </FormControl>
        日
      </Stack>
    </Stack>
  );
};

export default DateSelector;
